var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_528",
    "data-name": "Group 528",
    transform: "translate(14653)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_226",
    "data-name": "Rectangle 226",
    width: 24,
    height: 24,
    transform: "translate(-14653)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow_drop_down_circle_FILL0_wght300_GRAD0_opsz24",
    d: "M110-847.125l3.725-3.725h-7.449ZM110-840a9.741,9.741,0,0,1-3.9-.787,10.1,10.1,0,0,1-3.176-2.137,10.1,10.1,0,0,1-2.138-3.174A9.732,9.732,0,0,1,100-850a9.741,9.741,0,0,1,.787-3.9,10.1,10.1,0,0,1,2.137-3.176,10.1,10.1,0,0,1,3.174-2.138A9.732,9.732,0,0,1,110-860a9.742,9.742,0,0,1,3.9.787,10.1,10.1,0,0,1,3.176,2.137,10.1,10.1,0,0,1,2.138,3.174A9.732,9.732,0,0,1,120-850a9.741,9.741,0,0,1-.787,3.9,10.1,10.1,0,0,1-2.137,3.176,10.1,10.1,0,0,1-3.174,2.138A9.732,9.732,0,0,1,110-840Zm0-1.579a8.127,8.127,0,0,0,5.974-2.447A8.127,8.127,0,0,0,118.422-850a8.127,8.127,0,0,0-2.447-5.974A8.127,8.127,0,0,0,110-858.42a8.127,8.127,0,0,0-5.974,2.447A8.127,8.127,0,0,0,101.58-850a8.127,8.127,0,0,0,2.447,5.974A8.127,8.127,0,0,0,110-841.578ZM110-850Z",
    transform: "translate(-14751.001 861.999)",
    fill: "#15345a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.17ed6bd8e1177f0ba7f5f063b61ffc88.svg";
export { ForwardRef as ReactComponent };